<video #video *ngIf="source" [appVideoControl]="videoControl" class="p-2" [controls]="controls" [src]="source" (error)="sourceError.emit(true)">
</video>